import React from "react";
import { Ticket } from "../../../../../models/Ticket";
import EAModal from "../../../../shared/Modal/EAModal";
import { useTranslation } from "react-i18next";
import {
  getDisplayTicketType,
  getFormattedValidFromDate,
  getFormattedValidToDate,
  getTicketStatusSummary,
  isClubCard,
} from "../../../../../utils/TicketPassHelper";
import "./PassModal.scss";
import DetailsGrid from "./DetailsGrid";
import DetailsHeader from "./DetailsHeader";
import DetailsQR from "./DetailsQR";
import DetailsExercises from "./DetailsExercises";
import EAButton from "../../../../shared/Buttons/EAButton";
import EAAlert from "../../../../shared/EAAlert";
import useBasketManager from "../../../../FinalizePage/hooks/useBasketManager";
import { useNavigate } from "react-router-dom";
import { FINALIZE_PAGE } from "../../../../../routes";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  pass: Ticket;
  onRefreshTickets?: () => void;
}

const PassDetailsModal: React.FC<IProps> = ({ isOpen, onClose, pass, onRefreshTickets }) => {
  const { t } = useTranslation();
  const status = getTicketStatusSummary(pass);
  const entrancesLeft = pass.entrances - (pass.exercises?.length || 0);
  const { prolongPass } = useBasketManager();
  const navigate = useNavigate();

  // Mapa z danymi do wyświetlenia w gridzie
  const detailsData = [
    {
      key: "numer_karnetu",
      value: pass.trhId || "-",
    },
    {
      key: "typ",
      value: getDisplayTicketType(pass),
    },
    {
      key: "wazny_od",
      value: getFormattedValidFromDate(pass),
    },
    {
      key: "wazny_do",
      value: getFormattedValidToDate(pass),
    },
    ...(!isClubCard(pass.passtype)
      ? [
          {
            key: "wejscia",
            value: !pass.ticket && pass.entrances > 200 ? "OPEN" : `${entrancesLeft}/${pass.entrances}`,
          },
        ]
      : []),
  ];

  const handleExtendPass = () => {
    const newValidTo = new Date(pass.validto);
    newValidTo.setDate(newValidTo.getDate() + 1);
    prolongPass(pass.assortIds, 1, newValidTo);
    onClose();
    setTimeout(() => {
      navigate(FINALIZE_PAGE);
    }, 600);
  };

  return (
    <EAModal isOpen={isOpen} title={t("szczegoly_karnetu")} onClose={onClose} hideButtons desktopWidth="600px">
      <div className="ticket-details">
        {/* SEKCJA 1: Nazwa karnetu + Status */}
        <DetailsHeader pass={pass} title={t("szczegoly_karnetu")} />

        {/* SEKCJA 2: Szczegóły karnetu - 2 kolumny */}
        <DetailsGrid detailsData={detailsData} />

        {/* SEKCJA 3: Alert - jeśli karnet wymaga akcji */}
        {status.message && (
          <EAAlert
            type={status.color === "error" ? "error" : "warning"}
            message={status.message}
            compact={false}
            variant="chip"
          />
        )}

        {/* SEKCJA 4: QR Code */}
        <DetailsQR pass={pass} />

        {/* SEKCJA 5: Rezerwacje/Exercises */}
        <DetailsExercises pass={pass} onRefreshTickets={onRefreshTickets} />

        {/* SEKCJA 6: Przyciski */}
        <div className="ticket-details__actions">
          {pass.extendAllowed && (
            <EAButton title={t("przedluz_karnet")} variant="filled" onClick={handleExtendPass} fullWidth />
          )}
          <EAButton title={t("zamknij")} variant="outlined" onClick={onClose} fullWidth />
        </div>
      </div>
    </EAModal>
  );
};

export default PassDetailsModal;
